var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-editable",class:{ editing: _vm.editing, disabled: _vm.disabled },attrs:{"data-units":_vm.spacedUnits},on:{"dblclick":_vm.startEdit,"keypress":_vm.onKeypress,"input":_vm.onInput,"focus":_vm.onFocus,"blur":_vm.onBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }